import type { Comic, ComicSyncState } from '@tanko/shared'

/**
 * 作品同步狀態的判定。
 *
 * 這些判斷散落在上傳佇列、整理面板與書庫各處，任何一處判錯的後果都是資料層面的：
 * 誤判為已備份會讓作品被跳過而永遠沒有雲端副本，誤判為未備份則會重複上傳。
 * 因此集中在這裡，並且一律以 syncState 為準，不看 cloudComicId 是否有值。
 */
export const isBackedUp = (comic: Pick<Comic, 'syncState'>): boolean => comic.syncState === 'ready'
export const isRegistered = (comic: Pick<Comic, 'syncState'>): boolean => comic.syncState !== 'unregistered'

/**
 * 升級既有資料庫時的分流。
 *
 * 在目錄註冊之前，cloudComicId 只有在發布成功後才會寫入，因此有值等同於已備份。
 * 這個對應只在升級時使用一次；之後 syncState 由註冊與發布各自維護。
 */
export function initialSyncState(cloudComicId: string | null | undefined): ComicSyncState {
  return cloudComicId ? 'ready' : 'unregistered'
}
